import { useState } from 'react';
import { Dropdown, Menu } from 'antd';

import {
  FileAddOutlined,
  FileSyncOutlined,
  FileExcelOutlined,
  FileProtectOutlined,
} from '@ant-design/icons';

import gridSelector from 'common/components/grid-view/controllers/selectors';

import { RibbonButton } from 'common/components';
import { CERTIFICATE_ACTIONS } from './components/certificate-actions/constants';
import AddCertificateModal from './components/certificate-actions/AddCertificateModal';
import UpdateCertificateModal from './components/certificate-actions/UpdateCertificateModal';
import DeleteCertificateModal from './components/certificate-actions/DeleteCertificateModal';
import { useSelector } from 'react-redux';

const CertificateActions = ({ isFullView }) => {
  const [certificateActions, setCertificateActions] = useState();

  const selectedGridProducts = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const hasSelectedProduct = selectedGridProducts?.length > 0;

  const isEditCertificates = isFullView || hasSelectedProduct;

  const menu = (
    <Menu>
      <Menu.Item>
        <RibbonButton
          size='small'
          icon={<FileAddOutlined />}
          label='Add Certificate'
          onClick={() => setCertificateActions(CERTIFICATE_ACTIONS.ADD)}
        />
      </Menu.Item>
      <Menu.Item>
        <RibbonButton
          size='small'
          icon={<FileSyncOutlined />}
          label='Update Certificate'
          onClick={() => setCertificateActions(CERTIFICATE_ACTIONS.UPDATE)}
        />
        <UpdateCertificateModal />
      </Menu.Item>
      <Menu.Item>
        <RibbonButton
          size='small'
          icon={<FileExcelOutlined />}
          label='Delete Certificate'
          onClick={() => setCertificateActions(CERTIFICATE_ACTIONS.DELETE)}
        />
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown
        overlay={menu}
        placement='bottom'
        arrow={{ pointAtCenter: true }}
        disabled={!isEditCertificates}
      >
        <RibbonButton
          icon={<FileProtectOutlined />}
          label='Certificate Actions'
        />
      </Dropdown>
      {certificateActions === CERTIFICATE_ACTIONS.ADD && (
        <AddCertificateModal
          isFullView={isFullView}
          certificateActions={certificateActions}
          setCertificateActions={setCertificateActions}
        />
      )}

      {certificateActions === CERTIFICATE_ACTIONS.UPDATE && (
        <UpdateCertificateModal
          isFullView={isFullView}
          certificateActions={certificateActions}
          setCertificateActions={setCertificateActions}
        />
      )}
      {certificateActions === CERTIFICATE_ACTIONS.DELETE && (
        <DeleteCertificateModal
          isFullView={isFullView}
          certificateActions={certificateActions}
          setCertificateActions={setCertificateActions}
        />
      )}
    </>
  );
};

export default CertificateActions;
